import store from '../configureStore';

/**
 * Api prefix constants
 */
const baseUrl = process.env.REACT_APP_URLS_BASE_URL;
export const iosUrl = process.env.REACT_APP_IOS_URL;
export const iCalUrl = process.env.REACT_APP_ICAL_URL;
export const rcawLink = process.env.REACT_APP_RCAW_LINK;
const mwBaseUrl = process.env.REACT_APP_URLS_MW_BASE_URL;
export const aboutUs = process.env.REACT_APP_ABOUT_US_URL;
export const siteKey = process.env.REACT_APP_RECAPTCHA_KEY;
const regBaseUrl = process.env.REACT_APP_URLS_REG_BASE_URL;
const mngBaseUrl = process.env.REACT_APP_URLS_MNG_BASE_URL;
const cdnBaseUrl = process.env.REACT_APP_URLS_CDN_BASE_URL;
export const androidUrl = process.env.REACT_APP_ANDROID_URL;
export const trackerUrl = process.env.REACT_APP_URLS_TRACKER;
export const primaryColor = process.env.REACT_APP_PRIMARY_COLOR;
export const reportSaveUrl = process.env.REACT_APP_REP_SAVE_URL;
export const campaignBaseUrl = 'https://camp-srv.recyclecoach.com';
export const secondaryColor = process.env.REACT_APP_SECONDARY_COLOR;
export const otherCalUrl = process.env.REACT_APP_OTHER_CALENDAR_URL;
export const cityBaseUrl = process.env.REACT_APP_URLS_CITY_BASE_URL;
export const downloadPdfUrl = process.env.REACT_APP_DOWNLOAD_PDF_URL;
const mwBaseUrlSearch = process.env.REACT_APP_URLS_MW_BASE_URL_SEARCH;
export const googleMapDir = process.env.REACT_APP_GOOGLE_MAP_DIRECTION;
export const googleStaticMap = process.env.REACT_APP_GOOGLE_STATIC_MAP;
export const recaptchaBaseUrl = process.env.REACT_APP_RECAPTCHA_BASE_URL;
export const recycleCoachHelp = process.env.REACT_APP_RECYCLE_COACH_HELP;
export const googleCalendarUrl = process.env.REACT_APP_GOOGLE_CALENDAR_URL;
export const calendarIconUrl = process.env.REACT_APP_URLS_CALENDAR_ICON_URL;
export const firstSetupSearch = process.env.REACT_APP_FIRST_SEARCH_SETUP_URL;
export const pluginWebappUrl = process.env.REACT_APP_WEBAPP_PLUGIN_DETAILS_URL;
export const downloadPdfPolicyUrl = process.env.REACT_APP_DOWNLOAD_PDF_POLICY_URL;
export const trackerSystemURl = 'https://srv-webapp.recyclecoach.com/plugin/pages';
export const webCampaignBaseUrl = process.env.REACT_APP_URLS_WEB_CAMPAINGN_BASE_URL;

/**
 * @private
 *
 * This function is for fixing the query string
 */
function updateQueryStringParameter(uri, key, value) {
  const re = new RegExp(`([?&])${key}=.*?(&|$)`, 'i');
  const separator = uri.indexOf('?') !== -1 ? '&' : '?';
  if (uri.match(re)) {
    return uri.replace(re, `$1${key}=${value}$2`);
  }
  return `${uri + separator + key}=${value}`;
}

/**
 * @private
 * Api combination function
 */
const buildEndpoint = (prefix, path, lang) => {
  const state = store.store.getState();
  const url = `${prefix}/${path}`;
  if (
    state.config.langs
    && state.config.langs.length
    && lang
  ) {
    return updateQueryStringParameter(url, 'lang', lang);
  }
  return url;
};

/**
 * Api connstructors
 */
export default {
  // CMS
  imageUrl: (path) => `${cdnBaseUrl}/gallery/${path}`,
  getDropEventList: (project, district, id, lang) => buildEndpoint(baseUrl, `ws-p${project}-d${district}/${id}.json?appOnWeb=true`, lang),
  materialDetailsApi: (project, district, matId, lang) => buildEndpoint(baseUrl, `ws-p${project}-d${district}/material/${matId}.json`, lang),
  getDepoDetailsApi: (project, district, matId, lang) => buildEndpoint(baseUrl, `ws-p${project}-d${district}/drop-depot/${matId}.json`, lang),
  getEventDetailsApi: (project, district, matId, lang) => buildEndpoint(baseUrl, `ws-p${project}-d${district}/drop-event/${matId}.json`, lang),
  getGeneralPage: (project, district, link, lang) => buildEndpoint(baseUrl, `ws-p${project}-d${district}/${link.replace('page', 'json')}`, lang),
  getEventsApi: (project, district, matId, lang) => buildEndpoint(baseUrl, `ws-p${project}-d${district}/drop-event-list.json?matId=${matId}`, lang),
  getDeposApi: (project, district, matId, location, lang) => buildEndpoint(baseUrl, `ws-p${project}-d${district}/drop-depot-list.json?matId=${matId}${location}`, lang),
  getDropEventDetails: (project, district, id, lang) => buildEndpoint(baseUrl, `ws-p${project}-d${district}/drop-event/${id}.json?districtId=${district}&density=&appOnWeb=true`, lang),

  // WGW
  materialListApi: (localityId, lang) => buildEndpoint(baseUrl, `${localityId}/mats`, lang),
  wgwMaterialGroupApi: (localityId, lang) => buildEndpoint(baseUrl, `${localityId}/wgw-group-list.json`, lang),
  searchMaterialByTerm: (localityId, term, lang) => buildEndpoint(baseUrl, `${localityId}/material-list.json?q=${term}`, lang),
  materialsByGroupId: (localityId, groupId, lang) => buildEndpoint(baseUrl, `${localityId}/wgw-group-list.json?wgw_group_id=${groupId}`, lang),

  // Campaign
  activeCampaignUrl: (projectId, districtId) => `${campaignBaseUrl}/campaigns/active-campaign/${projectId}/${districtId}`,
  campaignUrl: ({
    projectId, districtId, uuid, lang, zones, campaignSource
  }) => `${webCampaignBaseUrl}/?projectId=${projectId}&districtId=${districtId}&uuid=${uuid}&lang=${lang}&zones=${zones}&campaignSource=${campaignSource}`,
  nationalSurveyUrl: (projectId, districtId, uuid, selectedLang) => `https://campaign.recyclecoach.com/?projectId=${projectId}&districtId=${districtId}&uuid=${uuid}&lang=${selectedLang}&web=true&type=nationalsurvey&runson=webapp`,

  // Zone Setup
  getPluginDetails: () => pluginWebappUrl,
  sendPluginTracker: () => trackerSystemURl,
  getCollectionDetails: (project, district, id, lang) => buildEndpoint(baseUrl, `ws-p${project}-d${district}/${id}.json?appOnWeb=true`, lang),
  getZoneJson: (projectId, districtId, term) => `${mwBaseUrlSearch}?sku=${projectId}&district=${districtId}&prompt=undefined&term=${term}`,
  getCityLinks: (project, district, lang) => buildEndpoint(baseUrl, `ws-p${project}-d${district}/gpg/residential-services.json?appOnWeb=true`, lang),
  zoneInfo: (projectId, districtId, lat, lng) => `${mwBaseUrl}/get_zones?project_id=${projectId}&district_id=${districtId}&lat=${lat}&lng=${lng}`,
  getScheduleJson: (projectId, districtId, zone) => `${mwBaseUrl}/app_data_zone_schedules?project_id=${projectId}&district_id=${districtId}&zone_id=${zone}`,
  getCollectionJson: (projectId, districtId, zone, lang) => `${regBaseUrl}/collections?project_id=${projectId}&district_id=${districtId}&zone_id=${zone}&lang_cd=${lang || 'en_US'}`,
  getLatAndLong: (term, uuid, projectId, districtId) => `https://api-city.recyclecoach.com/geo/address?address=${term}&uuid=${uuid}&project_id=${projectId}&district_id=${districtId}`,

  // Calendar Stuff
  downloadCal: () => `${mngBaseUrl}/api/pdf-subscription`,

  // New Stuff
  getNewsApi: (project, district, zoneStr, lang) => buildEndpoint(regBaseUrl, `getNews/${project}/${district}/${zoneStr}?appOnWeb=true`, lang),

  // Stay Informed
  stayInformedUrl: () => `${regBaseUrl}/register-appOnWeb/`,

  // Reminder
  reminderSignUp: `${process.env.REACT_APP_REMINDER_SIGNUP}`,

  // Report Problem
  problemReporterUrl: () => reportSaveUrl,

  // Mock System
  setupFromPluginIdApi: () => `${regBaseUrl}/plugin/getinfo`,

  // WWTK
  wwtkFeedback: (type) => ({
    poll: `${campaignBaseUrl}/feedback/submit-poll`,
    quiz: `${campaignBaseUrl}/feedback/submit-quiz`
  })[type],

  // Campaign
  getCampaignImage: (postfix) => `${cdnBaseUrl}/campaigns/${postfix}`,

  // Help
  getNextPickUp: (
    projectId, districtId, zoneStr, collectionId
  ) => `${cityBaseUrl}/zone-setup/next-schedule?project_id=${projectId}&district_id=${districtId}&zone_id=${zoneStr}&col_type_id=${collectionId.replace('collection-', '')}`
};
